import React from 'react'

import { string } from 'prop-types'

function EmptyMessage({ title, description = '' }) {
  return (
    <div className="cgt-legacy-text--align-center">
      <h3 className="cgt-legacy-heading--disabled">{title}</h3>
      <p className="cgt-legacy-text-default">{description}</p>
    </div>
  )
}

EmptyMessage.propTypes = {
  title: string.isRequired,
  description: string,
}

export default EmptyMessage
